import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function HomeStrokeIcon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				d="M12 1.75C12.4995 1.75 12.983 1.92636 13.3652 2.24805L22.4834 9.92676C22.7998 10.1936 22.8399 10.6667 22.5732 10.9834C22.3063 11.2999 21.8333 11.3399 21.5166 11.0732L12.3994 3.39551C12.2876 3.30146 12.1461 3.25 12 3.25C11.8539 3.25 11.7123 3.30146 11.6006 3.39551L2.48336 11.0732C2.16666 11.3399 1.69359 11.2999 1.42672 10.9834C1.16002 10.6667 1.20009 10.1936 1.51657 9.92676L10.6347 2.24805C11.0169 1.92636 11.5005 1.75 12 1.75Z"
				fill="currentColor"
			/>
			<path
				d="M14.25 15C14.25 14.8619 14.1381 14.75 14 14.75H9.99996C9.86189 14.75 9.74996 14.8619 9.74996 15V21.5C9.74996 21.9142 9.41418 22.25 8.99997 22.25H5.49997C3.98119 22.25 2.74996 21.0188 2.74996 19.5V9.5C2.74996 9.08579 3.08575 8.75 3.49996 8.75C3.91418 8.75 4.24996 9.08579 4.24996 9.5V19.5C4.24996 20.1904 4.8096 20.75 5.49997 20.75H8.24997V15C8.24997 14.0335 9.03348 13.25 9.99996 13.25H14C14.9665 13.25 15.75 14.0335 15.75 15V20.75H18.5C19.1904 20.75 19.75 20.1904 19.75 19.5V9.5C19.75 9.08579 20.0858 8.75 20.5 8.75C20.9142 8.75 21.25 9.08579 21.25 9.5V19.5C21.25 21.0188 20.0188 22.25 18.5 22.25H15C14.5858 22.25 14.25 21.9142 14.25 21.5V15Z"
				fill="currentColor"
			/>
		</svg>
	);
}

HomeStrokeIcon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default HomeStrokeIcon;
